$(() => {
  $(".toggle-api-key-btn").click(function(e) {
    e.preventDefault();
    $(this).hide();
    $(".api-key").show();
  });
  $(document).ready(function() {
    if (location.hash === "#api-key") {
      $("html,body").scrollTop(0);
    }
  });
});
